import { useSelector } from "react-redux";
import { IReduxAppState } from "../reducers";

export function useIsSuperuser() {
    const merchant = useSelector((state: IReduxAppState) => state.merchant);

    return {
        isSuperuser: merchant?.superuser ?? false,
        merchant: merchant
    }
}